import React, { useState, useRef, Component } from "react";
import HomePage from "../../pages/Homepage/Homepage";
import useStyles from "./styles";
import ProductDetails from "../../pages/Product-Details/ProductDetails";
import Aboutus from "../../pages/AboutUs/AboutUs"
import Contact from "../../pages/Contact/Contact"
import Chat from "../../pages/Messages/Chat"
import Cart from "../../pages/Cart/Cart"
import Wishlist from "../../pages/Wishlist/Wishlist"
import Products from "../../pages/Products/Products"
import Store from "../../pages/Store/Store"
import Login from "../../pages/Login/Login"
import Register from "../../pages/Register/Register"
import Checkout from "../../pages/Checkout/Checkout"
import MyAccountMainPage from "../../pages/AccountSection/MyAccountMainPage/MyAccountMainPage"
import AccountSettingsPage from "../../pages/AccountSection/AccountSettingsPage/AccountSettingsPage"
import Orders from "../../pages/AccountSection/Orders/Orders"
import Reviews from "../../pages/AccountSection/Reviews/Reviews"
import ReportProblem from "../../pages/AccountSection/ReportProblem/ReportProblem"
import SystemReportProblem from "../../pages/AccountSection/SystemProblemReport/SystemProblemReport"
import ChangePassword from "../../pages/AccountSection/ChangePassword/ChangePassword"
import SubscribedStores from "../../pages/AccountSection/SubscribedStores/SubscribedStores"
import ForgetPassword from "../../pages/Forget-Password/ForgetPassword"
import NewPassword from "../../pages/Forget-Password/NewPassword"


import {
  Switch as SwitchRouter,
  withRouter,
  Route,
} from "react-router-dom";

//importing haeder
import Header from "../Header/Header"
import Footer from "../Footer/Footer"

const Layout = () => {
  const classes = useStyles();

  return (
    <div>
      
      {/* HEADER HERE */}
      <Header />

      {/* PAGES CEONTENT HERE*/}
      <main className={classes.page}>
        <SwitchRouter>
          <Route path="/" exact component={HomePage} />
          {/* <Route  path="/buyer/login"  component={Login} />
          <Route  path="/buyer/register"  component={Register} /> */}
          <Route path="/product" component={ProductDetails}/>
          <Route path="/buyer/messages" component={Chat}/>
          <Route path="/aboutus" component={Aboutus}/>
          <Route path="/contact" component={Contact}/>
          <Route path="/cart" component={Cart}/>
          <Route path="/wishlist" component={Wishlist}/>
          <Route path="/products" component={Products}/>
          <Route path="/store" component={Store}/>
          <Route path="/checkout" component={Checkout} />
          <Route path="/forget-password" component={ForgetPassword} />
          <Route path="/reset-password" component={NewPassword} />
          
          {/* Account Pages */}
          <Route path="/account" component={MyAccountMainPage}/>
          <Route path="/settings" component={AccountSettingsPage}/>
          <Route path="/subscribed/stores" component={SubscribedStores}/>
          <Route path="/orders" component={Orders}/>
          <Route path="/reportOrderProblem" component={ReportProblem}/>
          <Route path="/reportSystemProblem" component={SystemReportProblem}/>
          <Route path="/reviews" component={Reviews}/>
          <Route path="/change/password" component={ChangePassword} />
        </SwitchRouter>
      </main>

      {/* FOOTER HERE */}
      < Footer />
    </div>
  );
};

export default withRouter(Layout);
